/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_Brief_PlaceholderInputs */

const cs_blog_ai_brief_placeholder = /** @type {(inputs: Blog_Ai_Brief_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volitelný úhel, publikum nebo fakta, která článek musí obsahovat.`)
};

const en_blog_ai_brief_placeholder = /** @type {(inputs: Blog_Ai_Brief_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional angle, audience, or facts the article must include.`)
};

/**
* | output |
* | --- |
* | "Optional angle, audience, or facts the article must include." |
*
* @param {Blog_Ai_Brief_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_brief_placeholder = /** @type {((inputs?: Blog_Ai_Brief_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Brief_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_brief_placeholder(inputs)
	return cs_blog_ai_brief_placeholder(inputs)
});